import { Instagram } from "lucide-react";
import { Sparkle } from "@/components/Icons";
import { Float, Smiley, Waver } from "@/components/Mascots";
import { FadeUp } from "@/components/motion";

const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.6 3c.42 2.36 1.98 3.94 4.4 4.24v3.06c-1.65.02-3.1-.5-4.4-1.42v6.63a5.9 5.9 0 1 1-5.9-5.9c.33 0 .65.03.97.08v3.14a2.8 2.8 0 1 0 1.93 2.66V3h3z" />
  </svg>
);

const scrollTo = (target) => window.__lenis?.scrollTo(target, { duration: 1.5 });

export default function Footer() {
  return (
    <footer className="on-green bg-flytab-green text-flytab-black px-4 md:px-10 pt-16 md:pt-24 overflow-hidden" data-testid="footer-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 md:pb-24">
        <div className="md:col-span-5 relative">
          <Float className="absolute -top-16 right-0 hidden lg:block z-10" amp={10} dur={6}>
            <Waver className="w-24 xl:w-28" />
          </Float>
          <FadeUp>
            <p className="font-display font-extrabold uppercase text-2xl md:text-3xl leading-tight tracking-tight max-w-sm">
              Un projet ? Une idée folle ? On est là.
            </p>
            <a
              href="mailto:contact@flytab.fr"
              className="inline-block mt-6 font-mono text-sm md:text-base underline decoration-2 underline-offset-4 hover:opacity-60 transition-opacity"
              data-testid="footer-email-link"
            >
              contact@flytab.fr
            </a>
          </FadeUp>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <FadeUp delay={0.1}>
            <p className="font-mono text-xs uppercase tracking-[0.3em] mb-5 opacity-60">Menu</p>
            <ul className="space-y-3 font-mono text-sm uppercase tracking-wider">
              <li><button onClick={() => scrollTo("#services")} className="hover:opacity-60 transition-opacity" data-testid="footer-link-services">Services</button></li>
              <li><button onClick={() => scrollTo("#manifesto")} className="hover:opacity-60 transition-opacity" data-testid="footer-link-manifesto">Manifeste</button></li>
              <li><button onClick={() => scrollTo("#contact")} className="hover:opacity-60 transition-opacity" data-testid="footer-link-contact">Contact</button></li>
            </ul>
          </FadeUp>
        </div>

        <div className="md:col-span-3 md:col-start-10">
          <FadeUp delay={0.2}>
            <p className="font-mono text-xs uppercase tracking-[0.3em] mb-5 opacity-60">Social</p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/flytab.fr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border-2 border-flytab-black p-3 hover:bg-flytab-black hover:text-flytab-green transition-colors" data-testid="footer-social-instagram">
                <Instagram className="w-5 h-5" strokeWidth={2.5} />
              </a>
              <a href="https://www.tiktok.com/@flytab2" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="rounded-full border-2 border-flytab-black p-3 hover:bg-flytab-black hover:text-flytab-green transition-colors" data-testid="footer-social-tiktok">
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </FadeUp>
        </div>
      </div>

      <div className="relative">
        <div className="absolute -top-8 md:-top-14 left-[4%] z-10">
          <Sparkle className="w-10 md:w-16" />
        </div>
        <div className="absolute -top-6 md:-top-10 right-[7%] z-10 rotate-12">
          <Smiley className="w-9 md:w-14" wink />
        </div>
        <div
          className="font-display font-black uppercase text-center leading-[0.78] tracking-[-0.03em] select-none text-[clamp(4rem,17.5vw,22rem)] translate-y-[0.12em]"
          aria-hidden="true"
          data-testid="footer-wordmark"
        >
          FLYTAB
        </div>
      </div>

      <div className="relative z-10 bg-flytab-green border-t-2 border-flytab-black py-4 px-4 md:px-10 pl-24 md:pl-44 flex flex-wrap items-center justify-between gap-2 font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] -mx-4 md:-mx-10">
        <span data-testid="footer-copyright">© 2026 FLYTAB Studio</span>
        <span>Paris — Worldwide</span>
        <span>Designé & codé avec bold</span>
      </div>
    </footer>
  );
}
